import { defineComponent as x, useCssVars as O, openBlock as a, createElementBlock as c, toDisplayString as b, computed as d, createElementVNode as s, createBlock as D, createCommentVNode as k, Fragment as M, ref as w, watch as P, normalizeClass as N, createStaticVNode as A, onMounted as B, onBeforeUnmount as R, renderList as z, unref as h, createVNode as H } from "//omikujistore.com/cdn/shop/t/10/assets/lib.vue.js?v=39460745490713962181759520844";
import { a as W, u as j, O as U } from "//omikujistore.com/cdn/shop/t/10/assets/v-useOmikujiEventBus-NUygTxYd.js?v=77258134192849111251759520903";
import F from "//omikujistore.com/cdn/shop/t/10/assets/lib.axios.js?v=163496142447338752001759520843";
import { u as G, _ as E } from "//omikujistore.com/cdn/shop/t/10/assets/v-useLocale-CrhIBLM-.js?v=104820010258233384051759520903";
const J = { class: "availability-badge" }, K = /* @__PURE__ */ x({
  __name: "AvailabilityBadge",
  props: {
    meta: {
      type: {},
      required: !0
    }
  },
  setup(e) {
    return O((t) => ({
      cc49c518: e.meta.color
    })), (t, o) => (a(), c("div", J, b(e.meta.text), 1));
  }
}), Q = { class: "product-card" }, X = ["href"], Y = { class: "image-area" }, Z = ["src", "alt"], ee = { class: "text-area" }, te = { class: "quick-links" }, re = ["href"], ae = {
  key: 1,
  class: "bol"
}, oe = ["href"], se = ["href"], ne = { class: "price-and-add-to-cart" }, ce = { class: "price" }, ie = ["innerHTML", "disabled"], le = /* @__PURE__ */ x({
  __name: "ProductCard",
  props: {
    product: {
      type: {},
      required: !0
    }
  },
  setup(e) {
    const t = e, { t: o } = G(), { publish: n } = W(), { formatMoney: i } = j(), v = d(() => t.product.images[0]), r = d(() => t.product.brand.text ? t.product.brand : t.product.licence.text ? t.product.licence : null), l = d(() => r.value ? `${r.value.url}?${r.value.filter}=${r.value.text}` : ""), f = d(() => t.product.collection), L = d(() => t.product.title), p = d(() => {
      const _ = t.product.variants.find((g) => g.id == t.product.default_variant_id);
      return _ != null && _.available ? _ : t.product.variants.find((g) => g.available) ?? t.product.variants[0];
    }), u = d(() => i(p.value.price)), m = d(() => p.value.available), V = d(() => m.value ? o.general.i_m_adding_to_cart + " 🡒" : o.general.out_of_stock);
    async function I() {
      const _ = new FormData();
      _.append("id", p.value.id.toString()), _.append("quantity", "1"), (await F.post("/cart/add", _)).status == 200 && (window.location = "/cart")
    }
    return (_, $) => {
      var g, C, S, T;
      return a(), c("div", Q, [
        s("a", {
          href: p.value.url
        }, [
          s("div", Y, [
            e.product.meta.availability_badge ? (a(), D(K, {
              key: 0,
              meta: e.product.meta.availability_badge
            }, null, 8, ["meta"])) : k("", !0),
            s("img", {
              class: "product_image",
              src: v.value.src,
              alt: v.value.alt
            }, null, 8, Z)
          ])
        ], 8, X),
        s("div", ee, [
          s("div", null, [
            s("div", te, [
              (g = r.value) != null && g.text ? (a(), c(M, { key: 0 }, [
                l.value ? (a(), c("a", {
                  key: 0,
                  href: l.value,
                  class: "bol"
                }, b((C = r.value) == null ? void 0 : C.text), 9, re)) : (a(), c("span", ae, b((S = r.value) == null ? void 0 : S.text), 1))
              ], 64)) : k("", !0),
              (T = f.value) != null && T.text ? (a(), c("a", {
                key: 1,
                class: "collection",
                href: f.value.url
              }, b(f.value.text), 9, oe)) : k("", !0)
            ]),
            s("a", {
              class: "title",
              href: p.value.url
            }, b(L.value), 9, se)
          ]),
          s("div", ne, [
            s("p", ce, b(u.value), 1),
            s("button", {
              type: "button",
              innerHTML: V.value,
              class: "ui-kit-btn-1 no-select add-to-cart-button",
              onClick: I,
              disabled: !m.value
            }, null, 8, ie)
          ])
        ])
      ]);
    };
  }
}), ue = /* @__PURE__ */ E(le, [["__scopeId", "data-v-cb00afcc"]]);
var y = /* @__PURE__ */ ((e) => (e[e.NO_SCROLL = 0] = "NO_SCROLL", e[e.START = 1] = "START", e[e.MIDDLE = 2] = "MIDDLE", e[e.END = 3] = "END", e))(y || {});
function de(e) {
  const t = w(
    0
    /* NO_SCROLL */
  ), o = w(
    0
    /* NO_SCROLL */
  );
  P(e, (r, l) => {
    l && l.removeEventListener("scroll", i), r && (r.addEventListener("scroll", i), i());
  });
  function n(r, l, f) {
    return f == l ? 0 : r == 0 ? 1 : r + l >= f - 1 ? 3 : 2;
  }
  function i() {
    e.value && (t.value = n(
      e.value.scrollTop,
      e.value.clientHeight,
      e.value.scrollHeight
    ), o.value = n(
      e.value.scrollLeft,
      e.value.clientWidth,
      e.value.scrollWidth
    ));
  }
  function v() {
    e.value && e.value.removeEventListener("scroll", i);
  }
  return { verticalScrollState: t, horizontalScrollState: o, clear: v };
}
const pe = {
  type: "button",
  class: "ui-kit-slider-arrow no-select nsrec"
}, _e = /* @__PURE__ */ x({
  __name: "SliderArrow",
  props: {
    direction: {
      type: String,
      required: !1,
      default: "right",
      validator: (e) => ["left", "right"].includes(e)
    }
  },
  setup(e) {
    return (t, o) => (a(), c("button", pe, [
      (a(), c("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "29",
        height: "17",
        viewBox: "0 0 29 17",
        fill: "none",
        class: N(["arrow", e.direction])
      }, o[0] || (o[0] = [
        A('<g clip-path="url(#clip0_1447_165)" data-v-5729fb1a><path d="M0.86853 8.5H27.3981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-5729fb1a></path><path d="M19.5812 1.3L27.3981 8.5L19.5812 15.7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-5729fb1a></path></g><defs data-v-5729fb1a><clipPath id="clip0_1447_165" data-v-5729fb1a><rect width="28.2667" height="16" fill="white" transform="translate(0 0.5)" data-v-5729fb1a></rect></clipPath></defs>', 2)
      ]), 2))
    ]));
  }
}), q = /* @__PURE__ */ E(_e, [["__scopeId", "data-v-5729fb1a"]]), ve = { class: "product-carousel__scroller-wrapper" }, fe = { class: "product-carousel__scroller-content" }, he = /* @__PURE__ */ x({
  __name: "ProductScroller",
  props: {
    carouselVariables: {
      type: {},
      required: !0
    }
  },
  setup(e) {
    const t = e, o = w(!1), n = w(null), i = w([]);
    function v() {
      n.value && (o.value = n.value.scrollWidth > window.innerWidth);
    }
    const { horizontalScrollState: r, clear: l } = de(n);
    B(() => {
      window.addEventListener("resize", v), v();
    }), R(() => {
      window.removeEventListener("resize", v), l();
    });
    const f = d(() => t.carouselVariables.products.slice(0, t.carouselVariables.max_element));
    function L(p) {
      if (!n.value) return;
      const u = i.value[0];
      n.value.scrollLeft += p * ((u == null ? void 0 : u.clientWidth) ?? 400);
    }
    return (p, u) => (a(), c("div", ve, [
      s("div", {
        ref_key: "scroller",
        ref: n,
        class: "product-carousel__scroller"
      }, [
        s("div", fe, [
          (a(!0), c(M, null, z(f.value, (m) => (a(), D(ue, {
            key: m,
            ref_for: !0,
            ref_key: "card",
            ref: i,
            class: "product-carousel__product-card",
            product: m
          }, null, 8, ["product"]))), 128))
        ])
      ], 512),
      [h(y).MIDDLE, h(y).END].includes(h(r)) ? (a(), D(q, {
        key: 0,
        class: "arrows no-mobile",
        direction: "left",
        onPointerup: u[0] || (u[0] = (m) => L(-1))
      })) : k("", !0),
      [h(y).MIDDLE, h(y).START].includes(h(r)) ? (a(), D(q, {
        key: 1,
        class: "arrows right no-mobile",
        onPointerup: u[1] || (u[1] = (m) => L(1))
      })) : k("", !0)
    ]));
  }
}), me = /* @__PURE__ */ E(he, [["__scopeId", "data-v-03ee959b"]]), be = { class: "product-caroussel" }, ge = { class: "product-carousel__header" }, ye = { class: "carousel-title" }, ke = /* @__PURE__ */ x({
  __name: "ProductCarousel",
  props: {
    liquid: {
      type: {},
      required: !0
    },
    designMode: {
      type: Boolean,
      required: !1
    }
  },
  setup(e) {
    const o = e.liquid.variables;
    return (n, i) => (a(), c("div", be, [
      s("div", ge, [
        s("h4", ye, b(h(o).title), 1)
      ]),
      H(me, { "carousel-variables": h(o) }, null, 8, ["carousel-variables"])
    ]));
  }
}), Ee = /* @__PURE__ */ E(ke, [["__scopeId", "data-v-eed2d81d"]]);
export {
  Ee as default
};
